import React, { useMemo } from "react";
import { Typography, styled } from "@material-ui/core";

import { TicketInfo } from "../../../api/services";
import { formatDate } from "../../../utils/formatDate";
import {
  CustomTableRow,
  MultiLineTableCell,
  SingleLineTableCell,
} from "../../../components/CustomTableComponents";
import { TicketStatusCell } from "./TicketStatusCell";
import { TicketPriorityCell } from "./TicketPriorityCell";
import { TicketDueCell } from "./TicketDueCell";

const TicketSingleLineCell = styled(SingleLineTableCell)(() => ({
  verticalAlign: "top",
}));

const TicketMultiLineCell = styled(MultiLineTableCell)(() => ({
  verticalAlign: "top",
}));

export const TicketRow: React.FC<{
  ticket: TicketInfo;
}> = ({ ticket }) => {
  const {
    raisedDttm,
    summary,
    status,
    priority,
    step,
    dueStatus,
    dueDttm,
    team,
    user,
  } = ticket;

  const { teamUser } = useMemo(() => {
    return {
      teamUser: [team, user].filter((v) => v != null).join(", ") || "-",
    };
  }, [team, user]);

  return (
    <CustomTableRow data-testid="TicketRow">
      <TicketSingleLineCell data-testid="TicketRow__TableCell--Created">
        <Typography variant="body1" component="span">
          {formatDate(raisedDttm)}
        </Typography>
      </TicketSingleLineCell>
      <TicketSingleLineCell data-testid="TicketRow__TableCell--Status">
        <TicketStatusCell status={status} />
      </TicketSingleLineCell>
      <TicketMultiLineCell data-testid="TicketRow__TableCell--Summary">
        <Typography variant="body1" component="span">
          {summary}
        </Typography>
      </TicketMultiLineCell>
      <TicketMultiLineCell data-testid="TicketRow__TableCell--Step">
        <Typography variant="body1" component="span">
          {step}
        </Typography>
      </TicketMultiLineCell>
      <TicketMultiLineCell data-testid="TicketRow__TableCell--TeamUser">
        <Typography variant="body1" component="span">
          {teamUser}
        </Typography>
      </TicketMultiLineCell>
      <TicketSingleLineCell data-testid="TicketRow__TableCell--Priority">
        <TicketPriorityCell priority={priority} />
      </TicketSingleLineCell>
      <TicketSingleLineCell data-testid="TicketRow__TableCell--Due">
        <TicketDueCell dueDttm={dueDttm} dueStatus={dueStatus} />
      </TicketSingleLineCell>
    </CustomTableRow>
  );
};
